import type { IFooterLink } from 'src/interfaces';

export const getCustomFooterLinks: () => IFooterLink[] | null = () => {
  try {
    if (window.FOOTER_LINKS) {
      const customFooterLinks = JSON.parse(window.FOOTER_LINKS);

      if (Array.isArray(customFooterLinks)) {
        return customFooterLinks;
      }
    }
  } catch (e) {
    console.log(e);
  }

  return null;
};
